import { Suspense, createElement, lazy } from "react";
import { createRoot } from "react-dom/client";
import { SpinnerContainer } from "./components/Spinner";
import "./styles/main.scss";

const container = document.getElementById("root") || document.body
const root = createRoot(container);

const AppLoader = lazy(() => import("./utils/AppLoader"));
root.render(
    createElement(Suspense, { fallback: createElement(SpinnerContainer, null) },
        createElement(AppLoader)
    )
);

// @ts-ignore
import('./manifest')
    .then(({ MANIFEST }) => console.debug(`[${MANIFEST.name}] ver: ${MANIFEST.version}; BuildedAt: ${new Date(MANIFEST.buildTS).toLocaleDateString()} ${new Date(MANIFEST.buildTS).toLocaleTimeString()}`))
    .catch(() => console.debug("MANIFEST not found"));